import "../App.css";
import "../styling/Home.css";
import Logo from "../images/main_logo.png";

import About from "./About";
import Events from "./Events/Events";
import Gallery from "./Gallery/Gallery";

// Common Elements
// import UpdatedNavBar from "../Components/UpdatedNavBar";
import ProgramNavBar from "../Components/ProgramNavBar";

import { useState } from "react";
import Modal from "react-bootstrap/Modal";

function Home() {
  const [show, setShow] = useState(true);

  const handleClose = () => setShow(false);

  return (
    <div>
      <div className="home_background" id="home_page">
        <ProgramNavBar />
        <Modal show={show} onHide={handleClose} centered size="sm">
          <Modal.Body>
            <a href="/#program">
              Click here to be taken to THAT SHOW's May 2026 Program
            </a>
          </Modal.Body>
        </Modal>
        <div className="left_center">
          <img className="main_logo" src={Logo} alt=""></img>
        </div>
      </div>
      <About />
      <Events />
      <Gallery />
    </div>
  );
}

export default Home;
